import { IGetNumeroUsuariosTotalUseCase } from "../../../presentation/useCases/read/get_numero_usuarios_total_use_case";
import { NroUsuariosTotal } from "../../models/nro_usuarios_total";
import { IAdministracaoRepository } from "../../repositories/administracao_repository";

/**
 * GetNumeroUsuariosTotalUseCase
 */

export class GetNumeroUsuariosTotalUseCase implements IGetNumeroUsuariosTotalUseCase {
  constructor(private readonly repository: IAdministracaoRepository) { }

  async execute(): Promise<NroUsuariosTotal> {
    const nroUsuariosTotal = await this.repository.getUsuariosTotal();
    return nroUsuariosTotal;
  }
}
